import { RouterProvider } from "react-router-dom";
import React from 'react';
import ReactDOM from 'react-dom/client';
import router from './router';
import './assets/css/global.css';
import './i18n';
import axios from "axios";
import { version } from "./utils/main.js";


class CacheCleaner {
  static clearOnce() {
    const savedVersion = localStorage.getItem('app_version');

    // Faqat versiya o‘zgarganda ishlasin
    if (savedVersion !== version) {
      console.log('🧹 Cache tozalanmoqda...');

      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => caches.delete(name));
        });
      }

      localStorage.removeItem("token");
      sessionStorage.clear();

      localStorage.setItem('app_version', version);
      window.location.reload();
    }
  }
}

CacheCleaner.clearOnce();


axios.defaults.baseURL = 'https://api.vodiymart.com/';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `token ${token}`;
  return config;
});

axios.interceptors.response.use(
  (response) => response,

  (error) => {
    const res = error?.response;
    const url = res?.config?.url;

    if (url && url.includes("master")) {
      if (res.status === 401) {
        return (window.location.href = `/login`);
      }
      if (res.status === 403) {
        return (window.location.href = `/uz/404/`);
      }
    }

    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
